var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('keep-alive',{attrs:{"include":_vm.keep_alive}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }